export function showError(error) {
	console.log(error.message);
	alert(
		"---- Error ----\n" +
			error.code.toString().split("-").join(" ").split("/").join(" error:  ")
	);
	return "";
}
